import { Box } from '@mui/material';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ContainerOrd } from '../../ContainerOrd';

export const Contract: FC = () => (
  <ContainerOrd>
    <Box>
      <Outlet />
    </Box>
  </ContainerOrd>
);
